var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ImageLoader, Texture } from "three";
class ImageLoaderService {
    constructor() {
        this.imageLoader = new ImageLoader();
        this.imagesCache = new Map();
        this.imageLoader.crossOrigin = "anonymous";
    }
    clearCache() {
        this.imagesCache.clear();
    }
    load(url_1) {
        return __awaiter(this, arguments, void 0, function* (url, force = false) {
            if (!force) {
                const image = this.imagesCache.get(url);
                if (image) {
                    return image;
                }
            }
            const image = yield this.imageLoader.loadAsync(url);
            this.imagesCache.set(url, image);
            return image;
        });
    }
    loadTexture(url, force = false) {
        const texture = new Texture();
        this.load(url, force)
            .then((image) => {
            texture.image = image;
            texture.needsUpdate = true;
        })
            .catch((error) => {
            console.error("loadTexture error", error);
        });
        return texture;
    }
}
export const imageLoaderService = new ImageLoaderService();
